const Red = {
  Red: {
    _000: '#FEF2F2',
    _100: '#FEE2E2',
    _200: '#FECACA',
    _300: '#FCA5A5',
    _400: '#F87171',
    _500: '#EF4444',
    _600: '#DC2626',
    _700: '#B91C1C',
    _800: '#991B1B',
    _900: '#7F1D1D',
  },
};

export default Red;
